import script from "./ModalManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalManager.vue?vue&type=script&setup=true&lang=js"

import "./ModalManager.vue?vue&type=style&index=0&id=21d70941&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d70941"]])

export default __exports__